import { render } from "./warehouse.vue?vue&type=template&id=6c161158"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__